// extracted by mini-css-extract-plugin
export default {"placeholder":"BUkZk","underline":"CV6qb"};